import { useCallback } from 'react';

import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import useLifecycle, {
  LIFECYCLE,
  Lifecycle,
} from '@sorare/core/src/hooks/useLifecycle';

export const useDismissFirstTime = () => {
  const { update, loading } = useLifecycle();
  const { currentUser } = useCurrentUserContext();
  const lifecycle = currentUser?.userSettings?.lifecycle as Lifecycle;

  const hasDismissed = lifecycle?.sawForYouFirstTime;

  const dismiss = useCallback(async () => {
    if (loading) return null;
    return update(LIFECYCLE.sawForYouFirstTime, true);
  }, [loading, update]);

  return {
    hasDismissed,
    dismiss,
  };
};
